<template>
  <ui-dropper
    v-if="modelBlog?.is_editing"
    chevron-left
    >
    <template #head>
      <div class="space-x-4">
        <b>Blog</b>
        <span>Actions</span>
      </div>
    </template>
    <div class=" p-5 space-y-4">
      <div class="flex flex-wrap gap-2">
        <h3 class="w-full" v-text="'Translations'"/>
        <ui-button class="flat">
          Translate all from
          <UiLanguageSwitcherInput
            v-model="dataTranslateFromLanguage"
            class="text-left max-w-[70px]"
            label=""
            />
          <ui-button
            class="dark"
            text="Lesgo"
            @click="() => {
              if (!modelBlog) {
                return notify({
                  text: 'Blog not found',
                  type: 'error'
                })
              }

              ws.send('blog.translate', {
                id: modelBlog.id,
                locale: dataTranslateFromLanguage,
              })

              notify({
                text: 'Translation of all started. Results will take over 2 minutes.<br><br><hr><br>Do not update the blog while translation is in progress<br>',
                timeout: 120000,
              })
            }"
            />
        </ui-button>
        <ui-button class="flat text-left">
          Translate from
          <UiLanguageSwitcherInput
            v-model="dataTranslateFromLanguage"
            class="text-left max-w-[70px]"
            label=""
            />
          to
          <UiLanguageSwitcherInput
            v-model="dataTranslateToLanguage"
            class="text-left max-w-[70px]"
            label=""
            />

          <ui-button
            class="dark"
            text="Lesgo"
            @click="() => {
              if (!modelBlog) {
                return notify({
                  text: 'Blog not found',
                  type: 'error'
                })
              }

              ws.send('blog.translate', {
                id: modelBlog.id,
                locale: dataTranslateFromLanguage,
                to_locale: dataTranslateToLanguage,
              })

              notify({
                text: 'Translation of all started. Results will take over 2 minutes.<br><br><hr><br>Do not update the blog while translation is in progress<br>',
                timeout: 120000,
              })
            }"
            />
        </ui-button>
        <span class="w-full" />
        <ui-button
          class="flat danger"
          text="Wipe all translations"
          @click="() => {
            if (!modelBlog) {
              return notify({
                text: 'Blog not found',
                type: 'error'
              })
            }

            ws.send('blog.wipeTranslation', {
              id: modelBlog.id,
              locale: 'all'
            })

            notify('Wiping all translations')
          }"
          />
        <ui-button
          class="flat danger"
          >
          Wipe translation
          <UiLanguageSwitcherInput
            v-model="dataTranslateFromLanguage"
            class="text-left max-w-[70px]"
            label=""
            />
          <ui-button
            class="dark"
            text="Lesgo"
            @click="() => {
              if (!modelBlog) {
                return notify({
                  text: 'Blog not found',
                  type: 'error'
                })
              }

              ws.send('blog.wipeTranslation', {
                id: modelBlog.id,
                locale: dataTranslateFromLanguage,
              })

              notify('Wiping '+dataTranslateFromLanguage)
            }"
            />
        </ui-button>
      </div>
      <hr>
      <div class="flex flex-wrap gap-2">
        <h3 class="w-full" v-text="'Files'"/>
        <ui-button
          text="Generate blog image"
          class="dark"
          @click="() => {
            if (!modelBlog) {
              return notify({
                text: 'Blog not found',
                type: 'error'
              })
            }

            ws.send('blog.newimage',{id: modelBlog.id})

            notify({
              text:'Generation started.<br><br><hr><br>Result will show in more than a minute<br>',
              timeout: 120000,
            })
          }"
          />
      </div>
      <hr>
    </div>
  </ui-dropper>
</template>

<script setup lang="ts">
const modelBlog = defineModel<Blog>()

const dataTranslateFromLanguage = ref<string>()
const dataTranslateToLanguage = ref<string>()
</script>
